(function ($) {
  $(function () {
    // Function to scroll smoothly to the element
    function smoothScrollToHash(hash) {
      const target = $(hash);
      if (target.length) {
        $('html, body').animate(
          { scrollTop: target.offset().top - 100 },
          800 // Duration in milliseconds
        );
      }
    }

    // Smooth scrolling when clicking anchor links
    $('a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      const hash = this.hash;
      if (hash) {
        smoothScrollToHash(hash);
        history.pushState(null, null, hash); // Update URL without reloading
      }
    });
  });
})(jQuery);
